const miMessages = {
  "main.name": "Ingoa",
  "main.sentiment": "Kare ā-roto",
  "main.urgency": "Tere",
  "main.language": "Reo",
  "main.agent": "Kaimahi",
  "main.property_name": "Ingoa rawa",
  "main.booking_number": "Tau tono",
  "main.check_out": "Whakawātea",
  "main.check_in": "Whakauru",
  "main.adults": "Ngā pakeke",
  "main.corporate_code": "Waehere kamupene",
  "main.group_code": "Waehere rōpū",
  "main.promo_code": "Waehere whakatairanga",
  "main.ai_response": "Whakautu AI",
  "main.template_response": "Whakautu tauira",
  "main.converttoticket": "Tahuri ki tīkiti",
  "main.switch_property": "Hurihia te rawa",
  "main.Group_id": "ID rōpū",
  "main.integration_id": "ID whakauru",
  "main.submit": "Tuku",
  "main.cancel": "Whakakore",
    "main.select_template": "Tīpakohia he tauira",
  "main.rooms": "Rūma",
  "main.rates": "Ngā utu",

  //footer
    "footer.knowledge": "Mātauranga",
  "footer.home": "Kāinga",
  "footer.help": "Āwhina",

  //ticket
  "ticket.thank_you": "Ngā mihi mō te tuku i te puka",
  "ticket.ticket": "Tīkiti",
  "ticket.details": "Whakakīhia te puka e whakamārama ana i ngā taipitopito o te tīkiti.",
  "ticket.select_category": "Kōwhiria te kāwai",
  "ticket.category": "Kāwai",
  "ticket.title": "Taitara",
  "ticket.notes": "Ngā kōrero",
  "ticket.status": "Tūnga",
  "ticket.assigned_to": "Kua tohaina ki",
  "ticket.submit_form": "Tuku Puka",


  "main.total": "Tapeke",
  "main.pastetooutlook": "Whakapiri ki Outlook",
  "main.children": "Tamariki",
  "main.promocode": "Waehere Whakatairanga/Kamupene/Rōpū",
  "main.exact_match_only": "Ōrite Tika Anake",
  "main.search": "Rapu",
  "main.no_rate_match": "Kāore he utu e hāngai ana ki tō kōwhiringa. Whakarerekētia tō rapunga ka ngana anō.",
  "main.translate_to": "Whakamāori ki",
  "main.regenerate": "Hanga Anō",
  "main.copy_text": "Tārua Kuputuhi",
  "main.additional_instructions": "Tohutohu Tāpiri",

  "faq.helpcenter": "Pokapū Āwhina",
  "faq.reply.email.sabre.question": "Me pēhea taku whakautu i tētahi īmēra mā te whakamahi i te Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Whakatuwheratia te īmēra ka whakarewahia te tāpiri Aven Hospitality. Ka taea e koe te kōwhiri i waenga i ngā kōwhiringa e toru: whakamahi tauira kua whakaritea, hanga whakautu AI, whakarerekē rānei i te īmēra hei tīkiti.",

  "faq.rates.availability.question": "Me pēhea taku tāpiri utu, wātea me ngā taipitopito rūma ki taku whakautu?",
  "faq.rates.availability.answer": "Whakamahia te āhuatanga + Rates hei whakauru i ngā taipitopito manuhiri pērā i ngā rā me te maha o ngā manuhiri. Ka tāpirihia e Concierge ngā utu me te wātea tika.",

  "faq.different.language.question": "Me aha au mēnā he reo kē te īmēra?",
  "faq.different.language.answer": "Ka āhei a Aven Hospitality Concierge ki te whakamāori i ngā īmēra taumai ki tō reo e pai ana.",

  "faq.pin.addin.question": "Me pēhea taku whakarite kia wātea tonu te tāpiri i Outlook?",
  "faq.pin.addin.answer": "Whakapirihia te tāpiri Aven Hospitality Concierge ki Outlook kia kitea tonutia.",

  "faq.knowledge.hub.question": "He aha te kōwhiringa rapu Knowledge Hub?",
  "faq.knowledge.hub.answer": "Ka āwhina te rapu Knowledge Hub ki te kimi tere i ngā pārongo motuhake o te rawa i roto i Outlook.",

  "faq.reply.email.myma.question": "Me pēhea taku whakautu i tētahi īmēra mā Myma?",
  "faq.reply.email.myma.answer": "Whakatuwheratia te īmēra ka whakarewahia te tāpiri Myma. Ka taea e koe te whakamahi tauira, hanga whakautu AI, whakarerekē rānei hei tīkiti.",

  "faq.room.details.question": "Me pēhea taku tāpiri taipitopito rūma ki taku whakautu?",
  "faq.room.details.answer": "Whakamahia + Rooms hei whakauru whakaahuatanga rūma me ngā whakaahua.",

  "faq.myma.different.language.question": "Me aha au mēnā he reo kē te īmēra?",
  "faq.myma.different.language.answer": "Ka āhei a Myma ki te whakamāori i ngā īmēra taumai ki tō reo e pai ana.",

  "faq.myma.pin.addin.question": "Me pēhea taku whakarite kia wātea tonu te tāpiri i Outlook?",
  "faq.myma.pin.addin.answer": "Whakapirihia te tāpiri Myma ki Outlook kia tūwhera aunoa me ia īmēra."

};
export default miMessages;